import { FAQsItem } from '@mygpt/app/faqs/services/list';
import { Http } from '@mygpt/app/http';
import { MsgCitation } from '@mygpt/types';
import { I18N_LANG_MAP } from '@mygpt/app/chat/constant';

export interface UpdateFAQsParams {
  // 数据集 ID
  datasetId: string;
  faqsId: string;
  question: string;
  answer: string;
  sources: string;
  language: string;
  session_message_id?: string;
  citation?: MsgCitation;
  is_search?: boolean; // 是否在问答里进行Q&A搜索
  // 本次修改是否同步翻译到同一语言包的其它语言；缺省时后端按 true 处理
  sync_translations?: boolean;
}

/**
 * 更新问答
 * @param params
 * @returns
 */
export const updateFAQsService = (params: UpdateFAQsParams) => {
  const { datasetId, faqsId, language, ...rest } = params;
  const { put } = Http.use();
  return put<FAQsItem>(`/datasets/${datasetId}/faqs/${faqsId}`, {
    ...rest,
    language: I18N_LANG_MAP[language],
  });
};
